export default function AttributionSection() {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 pb-16 pt-12 md:px-8 md:pb-20">
      <div className="rounded-lg border border-slate-200 bg-slate-50 p-5 md:p-6">
        <div className="flex items-start gap-3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-white text-slate-500 ring-1 ring-slate-200">
            <i className="ri-information-line text-lg" />
          </span>
          <div className="text-sm leading-relaxed text-slate-600">
            <p className="font-semibold text-slate-700">資料來源與聲明</p>
            <p className="mt-1.5">
              本健診依公開 Google Maps / Places 資料與天地人網自有評分規則產生，非 Google 官方評級。本工具不保證公開資料完整性。
            </p>
            <p className="mt-1.5 text-xs text-slate-500">
              本頁面不包含 Google Business Profile 後台的搜尋曝光、電話點擊、路線規劃等私有數據。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}